export const BASE_URL = process.env.REACT_APP_API_URL;
export const API_URL = BASE_URL + 'adminapi/' //"http://localhost:8000/adminapi/";
export const API_AUTH_URL = BASE_URL + 'auth/'
